import { Component, OnInit } from '@angular/core'
import { FormGroup, FormBuilder, Validators } from '@angular/forms'
import { CommonService } from 'src/app/services/common/common.service'

@Component({
  selector: 'app-login',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss']
})
export class LandingComponent implements OnInit {
  public companyDomainForm: FormGroup

  constructor(private formBuilder: FormBuilder, private cs: CommonService) {}

  ngOnInit(): void {
    this.buildCompanyDomainForm()
  }

  buildCompanyDomainForm() {
    this.companyDomainForm = this.formBuilder.group({
      companyDomain: ['', [Validators.required]]
    })
  }

  get f() {
    return this.companyDomainForm.controls
  }

  continue() {
    if (this.companyDomainForm.valid) {
      this.cs.routeTo('/login/' + this.f['companyDomain'].value)
    }
  }
}
